import { createFileRoute, redirect } from '@tanstack/react-router'
import { SupplierEditView } from '@/features/suppliers/suppliers'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/suppliers/$supplierId/edit')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'supplier.edit')) {
      throw redirect({
        to: '/suppliers/$supplierId',
        params: { supplierId: params.supplierId },
      })
    }
  },
  component: SupplierEditView,
})
